import React, { useEffect, useRef } from 'react';
import './Home.css';

function HomeBragBar() {
  // Array mit allen Logo-Pfaden
  const logos = [
    '/img/Logo_1.jpg',
    '/img/Logo_2.jpg',
    '/img/Logo_3.jpg',
    '/img/Logo_4.jpg',
    '/img/Logo_5.jpg',
    '/img/Logo_6.jpg',
    '/img/Logo_7.jpg',
    '/img/Logo_8.jpg',
    '/img/Logo_9.jpg',
    '/img/Logo_10.jpg',
    '/img/Logo_11.jpg',
    '/img/Logo_12.jpg',
  ];

  const containerRef = useRef(null);
  const trackRef = useRef(null);

  // Effekt für die Animation
  useEffect(() => {
    const container = containerRef.current;
    const track = trackRef.current;
    if (!container || !track) return;

    // Berechne die Gesamtbreite des Containers
    const logoWrappers = container.querySelectorAll('.home-brag-bar__logo-wrapper');
    if (logoWrappers.length === 0) return;
    
    const logoWidth = logoWrappers[0].offsetWidth;
    const totalWidth = logoWidth * (logos.length);

    // Starte die Animation
    let animationId = null;
    let position = 0;
    const speed = 0.5; // Geschwindigkeit der Animation

    const animate = () => {
      position -= speed;
      
      // Wenn wir weit genug gescrollt haben, setze die Position zurück,
      // aber so, dass es für den Betrachter nicht sichtbar ist
      if (Math.abs(position) >= totalWidth) {
        position += totalWidth;
      }
      
      // Wende die Position auf den Container an
      container.style.transform = `translateX(${position}px)`;
      
      animationId = requestAnimationFrame(animate);
    };

    animate();

    // Aufräumen
    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, [logos.length]);

  // Erstelle ein Array mit mehrfacher Wiederholung der Logos für einen nahtlosen Scroll
  const repeatedLogos = [];
  const repeatCount = 10; // Anzahl der Wiederholungen
  
  for (let i = 0; i < repeatCount; i++) {
    logos.forEach((logo, index) => {
      repeatedLogos.push({
        src: logo,
        key: `${i}-${index}`
      });
    });
  }

  return (
    <div className="home-brag-bar-wrapper">
      <h2 className="home-brag-bar__title">Partners and network</h2>
      <div className="home-brag-bar">
        <div className="home-brag-bar__track" ref={trackRef}>
          <div className="home-brag-bar__container" ref={containerRef}>
            {repeatedLogos.map((logo) => (
              <div 
                key={logo.key} 
                className="home-brag-bar__logo-wrapper"
              >
                <img
                  src={logo.src}
                  alt={`Partner Logo`}
                  className="home-brag-bar__logo"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeBragBar; 